export default __webpack_public_path__ + "static/media/demo-3.c7bf160e.png";